import AxiosPipeline from '@/services/api/pipeline/axios_pipeline'

export default {
  createPipestep: (data) => {
    // data: { pipeline_id, routine_id, pipe_order, fixed_param }
    return AxiosPipeline.post('pipestep', data, {
      headers: {
        'Content-Type': 'application/json'
      }
    })
  },

  updatePipestep: (pipe_step_id, data) => {
    // data: { pipe_order, fixed_param }
    return AxiosPipeline.put(`pipestep/${pipe_step_id}`, data, {
      headers: {
        'Content-Type': 'application/json'
      }
    })
  },

  getPipestepFromPipeline: (pipeline_id, params = {}) => {
    // params: pagination, etc.
    return AxiosPipeline.get(`pipestep/pipeline/${pipeline_id}`, { params })
  },

  getPipestepFromRoutine: (routine_id, params = {}) => {
    // params: pagination, etc.
    return AxiosPipeline.get(`pipestep/routine/${routine_id}`, { params })
  },

  deletePipestep: (pipe_step_id) => {
    return AxiosPipeline.delete(`pipestep/${pipe_step_id}`)
  }
}
